import { registerApi as api } from '../../api';


export const fetchform = async (unit_id) => {
  try {
    const client_ID = sessionStorage.getItem('selectedClient')
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/get_forms`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      params: {
        unit_id: unit_id
      }
    }
    );
    return response.data;
  } catch (error) {
    throw error.response.data.message
  }
};
export const fetchgetInputMatrixActivities = async () => {
  try {
    const client_ID = sessionStorage.getItem('selectedClient')
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/get_input_matrix_activities/${client_ID}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    }
    );
    return response.data;
  } catch (error) {
    const payload = error?.response?.data;
    throw payload?.message || payload?.error || error?.message || "Failed to load months";
  }
};
